import React from 'react';
import { Tooltip, Typography } from '@mui/material';

export const MetaCell: React.FC<{ values?: string[] }> = ({ values }) => {
  const [first, ...rest] = values ?? [];

  const cell = (
    <Typography
      variant="body2"
      color={first ? 'text.primary' : 'text.lightGrey'}
      noWrap
    >
      {first || 'n/a'}
    </Typography>
  );

  if (!rest.length) return cell;

  return (
    <Tooltip title={(values ?? []).join(', ')} placement="top">
      {cell}
    </Tooltip>
  );
};
